import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/employeeQueries.css"; // import custom styles (see below)
import EmployeeQueriesForm from "../components/EmployeeQueriesForm";
import { IoAdd } from "react-icons/io5";
import { QueriesBanner } from "../../../Assets";
import EmployeeQueriesList from "../components/EmployeeQueriesList";
import { mainAPikey, AppContext } from "../../../ContextApi";
import { useContext, useState, useEffect } from "react";
import { NotokenFound } from "../../../Utils";
import { useNavigate } from "react-router-dom";
import ReplyQueries from "../components/ReplyQueries";

const EmployeeQueries = ({ setViewType, viewType }) => {
  const [categoriesListOption, setCategoriesListOption] = useState([]);
  const [queriesListData, setQueriesListData] = useState([]);
  const [filteredQueriesData, setFilteredQueriesData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedQueryId, setSelectedQueryId] = useState(null);
  const [ticketDetailsData, setTicketDetailsData] = useState(null);
  const [repliesData, setRepliesData] = useState([]);

  const { requestOptions, callQueryListApi } = useContext(AppContext);

  const navigate = useNavigate();

  const [token, setToken] = useState(
    localStorage.getItem("authorizationToken") || ""
  );

  const fetchEmployeeQueriesList = async (page = 1) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/${mainAPikey}/employee/raised-query-ticket-list`,
        requestOptions
      );
      const data = await response.json();
      setQueriesListData(data.data); // the "data" array
      setTotalRows(data.total); // total number of items
    } catch (error) {
      console.error("Error fetching queries", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchChatList = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/${mainAPikey}/employee/ticket-chat-list?query_id=${selectedQueryId}`,
        requestOptions
      );
      const res = await response.json();
      if (res.data) {
        setRepliesData(res?.data);
      }
      if (!token) {
        NotokenFound(navigate);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchQueryCategories = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/${mainAPikey}/employee/ticket-category`,
          requestOptions
        );
        const res = await response.json();
        if (res.data) {
          setCategoriesListOption(res?.data);
        }
        if (!token) {
          NotokenFound(navigate);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchQueryCategories();
    fetchEmployeeQueriesList();
  }, []);

  useEffect(() => {
    fetchChatList();
  }, [selectedQueryId]);

  useEffect(() => {
    if (viewType == 0) {
      fetchEmployeeQueriesList();
    }
  }, [viewType]);

  useEffect(() => {
    fetchEmployeeQueriesList();
  }, [callQueryListApi]);

  const handleQueriesView = () => {
    setViewType(!viewType);
  };

  return (
    <>
      <div className="main-escalation-cover-wrapper claim-app-home-main-cover-wrapper employee-queries-main-cover">
        <div className="faq-main-cover-wrapper pt-0 py-4 pb-0 ">
          <div className="network-hospital-heading my-4">
            <h3 className="text-center">
              {viewType == 2 ? "Reply Queries" : "Queries"}

              {viewType == 0 ? (
                <button
                  className="add-new-queries-btn"
                  onClick={() => handleQueriesView()}
                >
                  <IoAdd />
                  Raise Queries
                </button>
              ) : (
                <button
                  className="add-new-queries-btn"
                  onClick={() => handleQueriesView()}
                >
                  View Queries
                </button>
              )}
            </h3>
          </div>
          {viewType == 0 ? (
            <EmployeeQueriesList
              queriesListData={queriesListData}
              currentPage={currentPage}
              totalRows={totalRows}
              setCurrentPage={setCurrentPage}
              loading={loading}
              setQueriesListData={setQueriesListData}
              setFilteredQueriesData={setFilteredQueriesData}
              filteredQueriesData={filteredQueriesData}
              setViewType={setViewType}
              viewType={viewType}
              setSelectedQueryId={setSelectedQueryId}
              selectedQueryId={selectedQueryId}
              setTicketDetailsData={setTicketDetailsData}
              ticketDetailsData={ticketDetailsData}
              setRepliesData={setRepliesData}
              repliesData={repliesData}
            />
          ) : viewType == 2 ? (
            <ReplyQueries
              setViewType={setViewType}
              viewType={viewType}
              selectedQueryId={selectedQueryId}
              ticketDetailsData={ticketDetailsData}
              repliesData={repliesData}
              setRepliesData={setRepliesData}
              fetchChatList={fetchChatList}
            />
          ) : (
            <div className="employee-queries-main-cover-wrapper mb-4">
              <div className="row d-flex align-items-center">
                <div className="col-lg-7">
                  <div className="queries-banner-cover-wrapper">
                    <img src={QueriesBanner} alt="Queries banner"></img>
                    <div className="queries-note-box">
                      <span className="label label-danger label-sm noteCommon">
                        Note!
                      </span>
                      <ul
                        className="padding-left-50"
                        style={{ marginBottom: 13, listStyleType: "none" }}
                      >
                        <li>
                          Please ensure that file format is one of the following
                          : xls, xlsx, doc, docx, png, jpeg, jpg, pdf
                        </li>
                        <li>Uploaded files should not be greater than 5 MB</li>
                        <li>Maximum Upload limit : 5 files</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <EmployeeQueriesForm
                    categoriesListOption={categoriesListOption}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <ToastContainer position="top-center" />
      </div>
    </>
  );
};

export default EmployeeQueries;
